import { defaultStyles } from 'react-file-icon';

export const fileIconStyles = {
   ...defaultStyles,
   jpeg: {
      ...defaultStyles.jpeg,
      color: '#CADEFF',
   },
   jpg: {
      ...defaultStyles.jpg,
      color: '#CADEFF',
   },
   png: {
      ...defaultStyles.png,
      color: '#CADEFF',
   },
};
